export const config = {
    publicKey: null as string | null,
    verificationError: false,
};
